import resource from '../resource';

export function createResponsible(responsible) {
  return resource.createResponsible(responsible);
}

export function getResponsibleList(params) {
  return resource.getResponsibleList(params).then(response => response.data);
}

export function getResponsible(id) {
  return resource.getResponsible(id).then(response => response.data);
}

export function editResponsible(id, responsible) {
  return resource.editResponsible(id, responsible);
}

export function deleteResponsible(responsible) {
  return resource.deleteResponsible(responsible);
}
